import { inject, Service } from '@angular/core';
import { Actions, ofActionSuccessful } from '@ngxs/store';
import { MatDialog } from '@angular/material/dialog';
import { Logout } from '@portal-core/auth/services/auth-data.service';

/**
 * Closes all material dialogs when the user logs out.
 * Listens to the Logout action from the auth data store to close the dialogs.
 */
@Service()
export class AuthDialogsEffect {
  private readonly actions$ = inject(Actions);
  private readonly dialog = inject(MatDialog);

  constructor() {
    this.actions$.pipe(
      ofActionSuccessful(Logout)
    ).subscribe(() => {
      this.dialog.closeAll();
    });
  }
}
